export default __webpack_public_path__ + "static/media/icon-checkbox.0bcefe09.svg";